export enum QUIZ_IDS {
  MT = 'pl-mt',
  MT_NT = 'pl-mt-nt',
  MT_HP = 'pl-mt-hp',
  MT_CS = 'pl-mt-cs',

  THREE_IN_ONE_NT = 'pl-3in1-nt',

  BR_NT = 'pl-br-nt',

  FF_1M = 'pl-ff-1m',
}

export const DEFAULT_QUIZ = QUIZ_IDS.MT;
